/**
 * PreviewCta — Contact CTA section
 */
import { RenderIcon } from './RenderIcon';

interface PreviewCtaProps {
  data: {
    title?: string;
    subtitle?: string;
    phone?: string;
    email?: string;
  };
  settings: {
    [key: string]: any;
  };
}

export function PreviewCta({ data, settings }: PreviewCtaProps) {
  return (
    <section className="preview-cta" id="kontakt">
      <div className="preview-container">
        <h2>{data.title}</h2>
        <p>{data.subtitle}</p>
        <div className="preview-cta__actions">
          <a
            href={`tel:${data.phone?.replace(/\s/g, "")}`}
            className="preview-btn preview-btn--accent"
          >
            <RenderIcon name="phone" />
            {data.phone}
          </a>
          <a
            href={`mailto:${data.email}`}
            className="preview-btn preview-btn--secondary"
          >
            <RenderIcon name="mail" />
            {data.email}
          </a>
        </div>
      </div>
    </section>
  );
}
